<script lang="ts" setup>
import Swal from "sweetalert2";
const airlinesStore = useAirlinesStore();
const localStorageStore = useLocalStorageStore();
const userStrore = useUserStore();
const config = useRuntimeConfig();
const kotaAsal = ref({
  id: "CGK",
  name: "SOEKARNO HATTA",
  city: "Jakarta - Cengkareng",
  country: "Indonesia",
  timezone: null,
  international: 0,
  domestic: 1,
  gmt: null
});
const kotaTujuan = ref({
  id: "DPS",
  name: "NGURAH RAI",
  city: "Denpasar, Bali",
  country: "Indonesia",
  timezone: null,
  international: 0,
  domestic: 1,
  gmt: null
});
const trip  = ref('O');
const airports = ref<any>({});
const airlines = ref<any>({})
const maskapai = ref("INTL")
const tgl_dep = ref();
const tgl_ret = ref();
const adt = ref(1);
const inf = ref(0);
const chd = ref(0);
const loading = ref(false);
const cabin = ref('economy');
const searchOrg = ref()
const searchDes = ref()
const negara = ref()
const interairports = ref<any>({});
const orgInput = ref();
const desInput = ref();
const isRoundTrip = ref(false);

const toggleRoundTrip = () => {
  if (isRoundTrip.value) {
    selectTrip('R')
  } else {
    selectTrip('O')
  }
}

const getAirports = () => {
  try {
    // Retrieve and parse the data from localStorage
    const response = localStorageStore.getInternationalAirport();

    airports.value = response;
  } catch (error) {
    console.error("Error:", error);
  }
};


const getAirlines =  () => {
  try{
    const response: any = localStorageStore.getAirlinesCode();
    airlines.value = response
  }catch(error){
    console.error(error)
  }
}


const setCabin = (value: string) => {
  cabin.value = value;
};

onMounted(() => {
  getAirports();
  getAirlines();
})

const selectTrip = (type: any) => {
  trip.value = type
}

const selectCabin = (type: any) => {
  cabin.value = type
}

const selectMaskapai = (type: any) => {
  maskapai.value = type
}

const isInternationalAirport = (code: any) => {
    return airports.value.some((airport: any) => airport.id === code && airport.international === 1);
};

const maxAdults = computed(() => Math.max(1, 7 - chd.value));
const maxChildren = computed(() => Math.max(0, 7 - adt.value));

const schedule = async() => {
  try{
    loading.value = true;

    const totalPassengers = adt.value + chd.value;
    if (totalPassengers > 7) {
      Swal.fire({
        title: 'Kesalahan Validasi',
        html: 'Total penumpang dewasa dan anak tidak boleh lebih dari 7.',
        icon: 'warning',
      });
      return; // Hentikan eksekusi fungsi
    }

    if (inf.value > adt.value) {
      Swal.fire({
        title: 'kesalahan Validasi',
        html: 'Jumlah bayi tidak boleh lebih dari jumlah dewasa.',
        icon: 'warning',
      });
      return; // Hentikan eksekusi fungsi
    }

    if(!tgl_dep.value){
      Swal.fire({
        title: 'kesalahan Validasi',
        html: 'Tanggal keberangkatan tidak boleh kosong',
        icon: 'warning',
      });

      return 
    }

    if(trip.value == 'R' && !tgl_ret.value){
      Swal.fire({
        title: 'kesalahan Validasi',
        html: 'Tanggal kepulangan tidak boleh kosong',
        icon: 'warning',
      });

      return
    }

    const data = {
      ac: maskapai.value,
      org: kotaAsal.value.id,
      des:kotaTujuan.value.id,
      trip: trip.value,
      tgl_dep: tgl_dep.value,
      tgl_ret: tgl_ret.value,
      adt: adt.value,
      chd: chd.value,
      inf: inf.value,
      class: cabin.value,
      international: isInternationalAirport(kotaAsal.value.id) || isInternationalAirport(kotaTujuan.value.id) ? 1 : 0
    }
    localStorage.setItem('airlinesReq', JSON.stringify(data))
    navigateTo('/airlines/schedules')
    // const response: any = await airlinesStore.getSchedule(data);
    //
    // if(response.status.code == 200){
    //   if(response.details?.journeys[0]?.flights.length > 0){
    //     navigateTo('/airlines/schedules')
    //   }else{
    //     Swal.fire({
    //       title: 'Warning',
    //       html: 'shedules not found',
    //       icon: 'warning',
    //     });
    //   }
    // }else{
    //   Swal.fire({
    //       title: 'kesalahan Validasi',
    //       html: `${response.status.message}`,
    //       icon: 'warning',
    //     });
    // }
  }catch(error){
    console.error(error)
  }finally{
    loading.value = false;
  }
}

const swapValues = () => {
  const temp = { ...kotaAsal.value };
  kotaAsal.value = { ...kotaTujuan.value };
  kotaTujuan.value = { ...temp };
};
</script>

<template>
    <Customloading v-if="loading" />
    <div>
      <div class="">
        <div class="form mx-2">
          <div class="my-3">
            <div class="row mb-3 mb-0-sm">
              <div class="col-12 col-lg-8 col-md-8">
                <div class="d-flex d-flex-sm">
                  <div class="col">
                    <div class="input-container">
                      <AirportSelect v-model="kotaAsal" label="Dari"/>  
                    </div>
                  </div>
                  <div class="mt-4 mx-2 text-center-sm mt-0-sm">
                    <div class="swap-button">
                      <button class="btn btn-primary" @click="swapValues">
                        <i class="fa-solid fa-repeat"></i>
                      </button>
                    </div>
                  </div>
                  <div class="col">
                    <div class="input-container">
                      <AirportSelect v-model="kotaTujuan" label="Ke"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-4 col-md-4 mb-3">
                <label for="dropdownPenumpang">Jumlah Penumpang</label>
                <button class="form-select rounded text-start" type="button" id="trip" data-bs-toggle="dropdown" aria-expanded="false">{{ `${adt} Dewasa` }}{{ chd > 0 ? `, ${chd} Anak` : '' }}{{ inf > 0 ? `, ${inf} Bayi` : '' }}</button>
                <ul class="dropdown-menu p-2" aria-labelledby="trip" @pointerdown.stop @click.stop>
                  <div class="mx-2 my-3">
                    <div class="row mt-3">
                      <div class="col col-lg-6 col-md-6">
                        <label>Dewasa</label><br>
                        <small class="pb-3" style="font-size: 10px;">(diatas 12 tahun)</small>
                      </div>
                      <div class="col col-lg-6 col-md-6">
                        <InputNumber v-model="adt" :min="1" :max="maxAdults" />
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col col-lg-6 col-md-6">
                        <label>Anak</label><br>
                        <small class="pb-3" style="font-size: 10px;">(2 - 11 tahun)</small>
                      </div>
                      <div class="col col-lg-6 col-md-6">
                        <InputNumber v-model="chd" :min="0" :max="maxChildren" />
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col col-lg-6 col-md-6">
                        <label>Bayi</label><br>
                        <small class="pb-3" style="font-size: 10px;">(dibawah 2 tahun)</small>
                      </div>
                      <div class="col col-lg-6 col-md-6">
                        <InputNumber v-model="inf" :min="0" :max="adt" />
                      </div>
                    </div>
                  </div>
                </ul>
              </div>
            </div>
            <div class="row mb-3 mb-0-sm">
              <div class="col-12 col-lg-4 col-md-4 mb-3">
                <label for="">Tanggal Pergi</label>
                <dateInput v-model="tgl_dep" />
              </div>
              <div class="col-12 col-lg-4 col-md-4 mb-3">
                <input type="checkbox" name="tanggal_pulang" style="transform: scale(1.5);" v-model="isRoundTrip" @change="toggleRoundTrip" id="tanggal_pulang"><label  style="margin-left: 5px;" for="tanggal_pulang">Tanggal Pulang</label>
                <dateInput v-model="tgl_ret" :minDate="tgl_dep" :disabled="trip !== 'R'" />
              </div>
              <!-- <div class="col-12 col-lg-3 col-md-3 mb-3">
                <label for="dropdownPesawat">Maskapai</label>
                <button class="form-select rounded text-start" type="button" id="maskapai" data-bs-toggle="dropdown" aria-expanded="false">{{ maskapai === 'ALL_MASKAPAI' ? 'Semua Maskapai' : maskapai === 'QZ' ? 'Air Asia' :  maskapai === 'QG' ? 'Citilink' : maskapai === 'GA' ? 'Garuda Indonesia' : maskapai === 'JT' ? 'Lion Air' : maskapai === 'IP' ? 'Pelita Air' : maskapai === 'SJ' ? 'Sriwijaya' : maskapai === 'MV' ? 'Trans Nusa' : maskapai === 'IL' ? 'Trigana Air' : maskapai === "ALL_INTL" ? 'Maskapai Internasional' : maskapai  }}</button>
                <ul class="dropdown-menu p-2" aria-labelledby="maskapai" style="cursor: pointer;">
                  <li class="ps-2 pe-4" @click="selectMaskapai('ALL_MASKAPAI')">Semua Maskapai</li>
                  <li class="ps-2 pe-4" @click="selectMaskapai('ALL_INTL')">Maskapai Internasional</li>
                  <li class="ps-2 pe-4" @click="selectMaskapai('QZ')">Air Asia</li> 
                  <li class="ps-2 pe-4" @click="selectMaskapai('QG')">Citilink</li> 
                  <li class="ps-2 pe-4" @click="selectMaskapai('GA')">Garuda Indonesia</li> 
                  <li class="ps-2 pe-4" @click="selectMaskapai('JT')">Lion Air</li> 
                  <li class="ps-2 pe-4" @click="selectMaskapai('IP')">Pelita Air</li> 
                  <li class="ps-2 pe-4" @click="selectMaskapai('SJ')">Sriwijaya</li> 
                  <li class="ps-2 pe-4" @click="selectMaskapai('MV')">Trans Nusa</li> 
                  <li class="ps-2 pe-4" @click="selectMaskapai('IL')">Trigana Air</li>
                </ul>
              </div> -->
              <div class="col-12 col-lg-4 col-md-4 mb-3">
                <label for="dropdownKelas">Kelas Penerbangan</label>
                <button class="form-select rounded text-start" type="button" id="cabin" data-bs-toggle="dropdown" aria-expanded="false">{{ cabin === 'economy' ? 'Ekonomi' : 'Bisnis' }}</button>
                <ul class="dropdown-menu p-2" aria-labelledby="cabin" style="cursor: pointer;">
                  <li class="ps-2 pe-4" @click="selectCabin('economy')">Ekonomi</li>
                  <li class="ps-2 pe-4" @click="selectCabin('business')">Bisnis</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-12 col-lg-12 col-md-12">
              <div class="row mb-3">
                <div class="col-12 col-lg-8 col-md-8">
                  <p><small>Perlu pesan tiket pesawat untuk grup yang besar? Hubungi <NuxtLink class="fw-bold text-dark text-decoration-none" to="/contact-us">Pemesanan Tiket Grup.</NuxtLink></small></p>
                </div>
                <div class="col-12 col-lg-4 col-md-4">
                  <button
                    type="button"
                    class="btn fw-semibold text-white mt-2"
                    @click="schedule"
                    style="width: 100%; background-color: #fb8b34"
                  >
                    Cari Tiket
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<style scoped>
/* .d-flex {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.input-container {
  flex: 1;
} */

.form-select {
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

/* .swap-button {
  display: flex;
  align-items: center;
  justify-content: center;
}

.swap-button .btn {
  padding: 0.5rem;
} */

.dropdown button:hover {
  cursor: pointer;
}

.scrollable-menu {
  max-height: 200px;
  overflow-y: scroll;
  scrollbar-width: none; /* For Firefox */
  -ms-overflow-style: none; /* For Internet Explorer and Edge */
}

.scrollable-menu::-webkit-scrollbar {
  display: none; /* For Chrome, Safari, and Opera */
}

.scrollable-menu li {
  display: block;
  position: relative;
  padding: 8px;
  width: 100%;
}

.scrollable-menu li .badge {
  position: absolute;
  right: 8px;
  top: 33%;
  transform: translateY(-50%);
}

.scrollable-menu li:hover {
  background-color: #f8f9fa;
}
</style>
